import {
  ORBIT_ECCENTRICITY,
  SEASON_STATIONS,
  type SeasonSnapshot,
} from "./geometry";

const CENTRE = { x: 400, y: 210 };
const ORBIT = { rx: 250, ry: 92 };

function stationPoint(dayOfYear: number) {
  const angle = ((dayOfYear - 172) / 365) * Math.PI * 2;
  return {
    x: CENTRE.x - ORBIT.rx * Math.sin(angle),
    y: CENTRE.y - ORBIT.ry * Math.cos(angle),
  };
}

export function SeasonsFallback({
  showPerihelion = false,
  snapshot,
}: {
  readonly showPerihelion?: boolean;
  readonly snapshot: SeasonSnapshot;
}) {
  const earth = stationPoint(snapshot.dayOfYear);
  const perihelion = stationPoint(3);
  // Sun sits at a focus: offset from the centre toward perihelion.
  const sun = {
    x: CENTRE.x + (perihelion.x - CENTRE.x) * ORBIT_ECCENTRICITY,
    y: CENTRE.y + (perihelion.y - CENTRE.y) * ORBIT_ECCENTRICITY,
  };

  return (
    <div className="fallback-exhibit">
      <div className="fallback-diagram">
        <svg
          aria-label="Sun at a focus of Earth's orbit, with Earth on a tilted-axis teaching path"
          className="fallback-orbit-svg"
          role="img"
          viewBox="0 0 800 420"
        >
          <ellipse
            cx={CENTRE.x}
            cy={CENTRE.y}
            fill="none"
            rx={ORBIT.rx}
            ry={ORBIT.ry}
            stroke="rgba(112, 169, 199, 0.7)"
            strokeWidth="2"
          />
          <circle cx={sun.x} cy={sun.y} fill="#ffb347" r="22" />
          <circle cx={sun.x} cy={sun.y} fill="#fff3d6" r="12" />
          <text
            fill="#ffe3a3"
            fontSize="14"
            textAnchor="middle"
            x={sun.x}
            y={sun.y + 42}
          >
            Sun
          </text>
          {showPerihelion ? (
            <>
              <circle cx={CENTRE.x} cy={CENTRE.y} fill="#8aa0b8" r="4" />
              <text
                fill="#8aa0b8"
                fontSize="11"
                textAnchor="middle"
                x={CENTRE.x}
                y={CENTRE.y - 12}
              >
                Ellipse centre
              </text>
              <circle
                cx={perihelion.x}
                cy={perihelion.y}
                fill="#ffd166"
                r="5"
              />
              <text
                fill="#ffd166"
                fontSize="12"
                textAnchor="middle"
                x={perihelion.x}
                y={perihelion.y - 16}
              >
                Perihelion
              </text>
            </>
          ) : null}
          {SEASON_STATIONS.map((station) => {
            const point = stationPoint(station.dayOfYear);
            return (
              <g key={station.label}>
                <circle
                  cx={point.x}
                  cy={point.y}
                  fill={
                    station.index === snapshot.seasonIndex
                      ? "none"
                      : "rgba(115, 169, 216, 0.45)"
                  }
                  r="8"
                />
                <text
                  fill={
                    station.index === snapshot.seasonIndex
                      ? "#ffd166"
                      : "#94a3bb"
                  }
                  fontSize="13"
                  textAnchor="middle"
                  x={point.x}
                  y={point.y + 28}
                >
                  {station.shortName}
                </text>
              </g>
            );
          })}
          <circle cx={earth.x} cy={earth.y} fill="#3f6ea8" r="18" />
          <line
            stroke="#e9eef7"
            strokeWidth="2"
            transform={`rotate(-23.4 ${earth.x} ${earth.y})`}
            x1={earth.x}
            x2={earth.x}
            y1={earth.y - 28}
            y2={earth.y + 28}
          />
        </svg>
      </div>
    </div>
  );
}
